import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "opModal"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "midTitle text-center mb-2" }, "Stato macchina", -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Prenotazione identifier", -1)
const _hoisted_5 = { class: "form-control" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Stato macchina", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Durata impulso", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Durata trattamento di ogni punto", -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Punto attuale", -1)
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Secondi trascorsi", -1)
const _hoisted_16 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.prenotazione)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.prenotazioneIdentifier), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prenotazione.statoMacchinaAntismoking.statoMacchina) = $event))
          }, null, 512), [
            [_vModelText, _ctx.prenotazione.statoMacchinaAntismoking.statoMacchina]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prenotazione.statoMacchinaAntismoking.durataImpulso) = $event))
          }, null, 512), [
            [_vModelText, _ctx.prenotazione.statoMacchinaAntismoking.durataImpulso]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prenotazione.statoMacchinaAntismoking.durataTrattamentoPunto) = $event))
          }, null, 512), [
            [_vModelText, _ctx.prenotazione.statoMacchinaAntismoking.durataTrattamentoPunto]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prenotazione.statoMacchinaAntismoking.puntoTrattamento) = $event))
          }, null, 512), [
            [_vModelText, _ctx.prenotazione.statoMacchinaAntismoking.puntoTrattamento]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prenotazione.statoMacchinaAntismoking.secondiTrascorsi) = $event))
          }, null, 512), [
            [_vModelText, _ctx.prenotazione.statoMacchinaAntismoking.secondiTrascorsi]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, "Salva"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
          }, "Refresh"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
          }, "Chiudi")
        ])
      ]))
    : _createCommentVNode("", true)
}